import { ApiConfig, HttpService, QueryHandler, TaggedUrl, Tags } from '@skylab-shared/core';
import { MS_PER_MINUTE } from '@skylab-shared/utils';
import { ReportPrintQuery, ReportPrintQueryParameters, ReportPrintResult } from '../queries/report-print.query-base';


export interface ReportInventoryStocktakingPrintResult extends ReportPrintResult { }

export interface ReportInventoryStocktakingPrintParameters extends ReportPrintQueryParameters { }

export class ReportInventoryStocktakingPrintQuery extends ReportPrintQuery<ReportInventoryStocktakingPrintResult> {
    public constructor(
        public override readonly parameters: ReportInventoryStocktakingPrintParameters
    ) {
        super(parameters);
    }
}

export class ReportInventoryStocktakingPrintQueryHandlerBase implements QueryHandler<ReportInventoryStocktakingPrintQuery, ReportInventoryStocktakingPrintResult> {
    private static Url = TaggedUrl.join('inventoryStocktaking/printing', [Tags.Api]);

    public constructor(private readonly http: HttpService) {}

    public async handleAsync({ parameters }: ReportInventoryStocktakingPrintQuery): Promise<ReportInventoryStocktakingPrintResult> {
        const requestData = {
            compress: parameters.compress,
            password: parameters.password,
            ecoMode: parameters.ecoMode,
            landscape: parameters.landscape,
            config: {
                parameters: JSON.stringify(parameters.parameters),
                summary: parameters.summary,
                columns: parameters.columns,
                report: 'Bilans'
            }
        };

        const { data } = await this.http.post<{ url: string; }>(ReportInventoryStocktakingPrintQueryHandlerBase.Url, requestData, {timeout: 3 * MS_PER_MINUTE });

        return {
            url: `${ApiConfig.baseUrl}${data.url}`
        };
    }
}
